import ParentLoginScene from './ParentLoginScene'
export default ParentLoginScene